import { useTranslation } from "@vixi/localization";
import { LangKey } from "@vixi/localization";
import { FC, ReactNode } from "react";

// Props
interface StatCardProps {
  pretitle: LangKey;
  title: LangKey;
  value: number;
  valueType?: "currency" | "integer" | "float" | "percent";
  prompt?: ReactNode;
}

export const StatCard: FC<StatCardProps> = ({ title, value, valueType, pretitle, prompt }) => {
  const { t, localeDetails } = useTranslation();

  const formattedValue = new Intl.NumberFormat(localeDetails.locale, {
    style: valueType === "currency" ? "currency" : "decimal",
    currency: valueType === "currency" ? "USD" : undefined,
    maximumFractionDigits: valueType === "percent" ? 2 : valueType === "float" ? 2 : 0,
  }).format(value);

  return (
    <div className="bg-paper flex gap-5 rounded px-5 py-3.5">
      <div>
        <p className="fw-400 fs-16 text-current">{t(pretitle)}</p>
        <div className="mt-1.5 flex items-center gap-5">
          <h1 className="fs-32 ps-2.5 text-center font-bold text-current">
            {formattedValue} {valueType === "percent" ? "%" : null}
          </h1>
          <h3 className="fs-17 font-bold text-current">{t(title)}</h3>
        </div>
      </div>
      {prompt}
    </div>
  );
};
